import { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { IStore } from '../../interfaces';
import { IReserveTeamTooltip } from '../../interfaces/clientInterfaces';
import * as actions from '../../actions';
import { useClickOutside } from '../../utils/useClickOutside';
import { useAppDispatch } from '../../utils/modules';
interface IReserveTeamTooltipContainer {
	x: number;
	y: number;
	isMobileViewActive: boolean;
}
const ReserveTeamTooltipContainer = styled.div<IReserveTeamTooltipContainer>`
	position: absolute;
	left: ${props => props.x - 275}px;
	top: ${props => props.y}px;
	font-size: 12px;
	width: 275px;
	min-height: 60px;
	border-radius: 4px;
	border: 1px  solid #F89504;
	color: white;
	text-align: center;
	text-shadow: 2px 2px 2px gold;
	background-color: black;
	padding: 8px;
	opacity: 0.8;
	user-select: none;
	z-index: 1111114;
	p {
		margin: 5px 0 0 0;
	}
`;

interface IDescriptionContainer {
	isMobileViewActive: boolean;
}
const DescriptionContainer = styled.div<IDescriptionContainer>`
	min-height: 50px;
	max-height: ${props => props.isMobileViewActive ? '120px' : '200px'};
	overflow-y: auto;
	margin-bottom: 8px;
`;

//#endregion


export default function ReserveTeamTooltip() {

	const dispatch = useAppDispatch();

	const containerRef = useRef<HTMLDivElement>(null);

	const isMobileViewActive = useSelector(
		(completeState: IStore): boolean => {
			return !!completeState?.ui?.isMobileViewActive;
		});

	const reserveTeamTooltip = useSelector(
		(completeState: IStore): IReserveTeamTooltip | null => {
			return completeState?.ui?.reserveTeamTooltip || null;
		});

	const onClickOutside = useCallback(() => {
		dispatch(actions.setReserveTeamTooltip(null));
	}, [dispatch]);

	useClickOutside(containerRef, onClickOutside);

	if (!reserveTeamTooltip) {
		return null;
	}
	return (
		
		<ReserveTeamTooltipContainer ref={containerRef} isMobileViewActive={isMobileViewActive} x={reserveTeamTooltip.x} y={reserveTeamTooltip.y - 15}>
			<DescriptionContainer
				isMobileViewActive={isMobileViewActive}
			>
				{reserveTeamTooltip.text}
			</DescriptionContainer>
		</ReserveTeamTooltipContainer>
	);
}
